import Network from './network';

const ENDPOINT = 'Api/MetricDefinitions';

export async function GetMetricDefinitions(type, cancelToken) {
  var res = await Network.Get(ENDPOINT, { type }, cancelToken);
  return res.data.items;
}